/** Runtime configuration injected by Flask via window.__AUTOPOD_CONFIG */
interface AutoPodConfig {
  playerUrl: string;
  rssBaseUrl: string;
  dashboardUrl: string;
}

const defaults: AutoPodConfig = {
  playerUrl: 'https://player.autopod.xyz',
  rssBaseUrl: 'https://rss.autopod.xyz',
  dashboardUrl: 'https://dashboard.autopod.xyz',
};

const injected = (window as any).__AUTOPOD_CONFIG as Partial<AutoPodConfig> | undefined;

export const config: AutoPodConfig = { ...defaults, ...injected };
